export const searchMealType: any = {
  allMeals: "三食付き",
  breakfastAndDinner: "朝・夕付き",
  breakfast: "朝食付き",
  lunch: "昼食付き",
  dinner: "夕食付き",
  nothing: "なし",
};
